"use client"

import { Accordion } from "@chakra-ui/react/accordion"
import React, { useEffect, useRef, useState } from "react"

import { Experience } from "@/types/getAbout"

import AccordionExperienceItem from "./AccordionExperienceItem"

interface IExperienceCard {
  data: Experience[]
  className: string
}

const AccordionExperience: React.FC<IExperienceCard> = ({
  className,
  data,
}) => {
  const [value, setValue] = useState([""])
  const scrollPosRef = useRef(0)

  useEffect(() => {
    // Restore scroll position after accordion animation
    if (scrollPosRef.current !== 0) {
      window.scrollTo({ behavior: "instant", top: scrollPosRef.current })
      scrollPosRef.current = 0
    }
  }, [value])

  const handleValueChange = (details: { value: string[] }) => {
    // Save current scroll position
    scrollPosRef.current = window.scrollY
    setValue(details.value)
  }

  return (
    <Accordion.Root
      className={className}
      collapsible
      data-umami-event={"accordion-experience"}
      display={"flex"}
      flexDirection="column"
      gap={2}
      onValueChange={handleValueChange}
      value={value}
      variant={"plain"}
    >
      {undefined !== data &&
        data.map((experience, index) => (
          <AccordionExperienceItem
            experience={experience}
            index={index}
            key={experience.id}
          />
        ))}
    </Accordion.Root>
  )
}

export default AccordionExperience
